var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DealBoardWidget',{key:`${_vm.boardRef}-board`,attrs:{"orgRef":_vm.orgRef,"boardRef":_vm.boardRef,"nest-modals":"","auto-load":"","read-only":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }